import home from '@/router/routes/home'
import childPage from '@/router/routes/childPage'
import formOfSupport from '@/router/routes/formOfSupport'
import formOfDonorData from '@/router/routes/formOfDonorData'
import summary from '@/router/routes/summary'
import errorPages from '@/router/routes/errorsPages'
import closed from '@/router/routes/closed'
import catchAll from '@/router/routes/catchAll'
import installmentsPayment from '@/router/routes/installmentsPayment'

import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  ...closed,
  ...home,
  ...summary,
  installmentsPayment,
  ...errorPages,
  formOfSupport,
  formOfDonorData,
  ...childPage,
  catchAll
]

export default routes
